export const SYS_ADMIN = 'sys_admin';
export const INSTANCE_OWNER = 'instance_owner';
export const INSTANCE_ADMIN = 'instance_admin';
export const PROFESSIONAL_LEADER = 'professional_leader';
export const FOOD_SPECIALIST = 'food_specialist';
export const FOODIE = 'foodie';
export const SOURCE_PROVIDER = 'source_provider';
export const CONTRIBUTOR = 'contributor';
export const FAMILY_LEADER = 'family_leader';
export const SELF_LEADER = 'self_leader';
export const PARTICIPANT = 'participant';
export const PUBLIC = 'public';

export const SCOPES = {
  SYS_ADMIN: [
    SYS_ADMIN,
  ],
  INSTANCE_OWNER: [
    INSTANCE_OWNER,
  ],
  STAFF: [
    SYS_ADMIN,
    INSTANCE_OWNER,
    INSTANCE_ADMIN,
    PROFESSIONAL_LEADER,
    FOOD_SPECIALIST,
    FOODIE,
    SOURCE_PROVIDER,
    CONTRIBUTOR,
  ],
  INSTANCE_STAFF: [
    INSTANCE_OWNER,
    INSTANCE_ADMIN,
    PROFESSIONAL_LEADER,
    FOOD_SPECIALIST,
    FOODIE,
    SOURCE_PROVIDER,
    CONTRIBUTOR,
  ],
  INSTANCE_MGMT: [
    INSTANCE_OWNER,
    INSTANCE_ADMIN,
  ],
  PROFESSIONAL: [
    PROFESSIONAL_LEADER,
    FOOD_SPECIALIST,
    FOODIE,
    SOURCE_PROVIDER,
    CONTRIBUTOR,
  ],
  PERSONAL: [
    FAMILY_LEADER,
    SELF_LEADER,
  ],
  LEADER: [
    PROFESSIONAL_LEADER,
    FOODIE,
    FAMILY_LEADER,
  ],
  CREATOR: [
    PROFESSIONAL_LEADER,
    FOOD_SPECIALIST,
    FOODIE,
    SOURCE_PROVIDER,
    CONTRIBUTOR,
    FAMILY_LEADER,
    SELF_LEADER,
  ],
  LICENSED: [
    SYS_ADMIN,
    INSTANCE_OWNER,
    INSTANCE_ADMIN,
    PROFESSIONAL_LEADER,
    FOOD_SPECIALIST,
    FOODIE,
    SOURCE_PROVIDER,
    CONTRIBUTOR,
    FAMILY_LEADER,
    SELF_LEADER,
    PARTICIPANT,
  ],
  EVERYONE: [
    SYS_ADMIN,
    INSTANCE_OWNER,
    INSTANCE_ADMIN,
    PROFESSIONAL_LEADER,
    FOOD_SPECIALIST,
    FOODIE,
    SOURCE_PROVIDER,
    CONTRIBUTOR,
    FAMILY_LEADER,
    SELF_LEADER,
    PARTICIPANT,
    PUBLIC,
  ],
  PARTICIPANT: [
    PARTICIPANT,
  ],
};



// WEBPACK FOOTER //
// ./src/constants/roles.js